import { withoutDefaults } from '@wix/bex-core';
import { cairoDataExAddCustomField } from '@wix/bex-core/bi';
import React from 'react';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { AddCustomFieldCTAButton } from './AddCustomFieldCTAButton';
import { Box, Divider } from '@wix/design-system';

export function CustomColumnsAddCustomFieldCTAButton() {
  const toolbar = useToolbarCollectionContext();
  const state = toolbar.collectionDataExtension?.dataExtension;

  if (state == null) {
    return null;
  }

  return (
    <Box direction="vertical" width="100%">
      <Divider direction="horizontal" />
      <Box
        padding="SP4"
        width="100%"
        boxSizing="border-box"
        direction="vertical"
      >
        <AddCustomFieldCTAButton
          state={state}
          onClick={() => {
            toolbar.reportBi(
              withoutDefaults(cairoDataExAddCustomField)({
                origin: 'Custom columns panel',
              }),
            );

            state.openCustomFieldModal({
              origin: 'Custom columns panel',
            });
          }}
        />
      </Box>
    </Box>
  );
}
